import {FC} from "react";
import {Container, Tab} from "semantic-ui-react";

import VenueConfigs from "./VenueConfigs/VenueConfigs";
import SQSConfig from "./SQSConfig/SQSConfig";

const ConfigsTabPanes: FC = () => {
    const panes = [
        {menuItem: "Venues", render: () => <Tab.Pane><VenueConfigs/></Tab.Pane>},
        {menuItem: "SQS", render: () => <Tab.Pane><SQSConfig/></Tab.Pane>}
    ];

    return (
        <Container style={{margin: "20px 0 0 0"}}>
            <Tab panes={panes}/>
        </Container>
    );
};

export default ConfigsTabPanes;
